<template>
  <div class="bg-white shadow-md relative rounded-lg p-8">
    <el-dialog title="" :visible.sync="centerDialogVisibleg" width="30%" center>
      <template slot="title">
        <h2 class="text-lg text-left text-white font-semibold">
          {{ AddEdit }} Portfolio
        </h2>
      </template>
      <el-form role="form" :model="ruleForm" :rules="rules" ref="ruleForm">
        <div>
          <div class="mb-3">
            <small class="fsize12 bg-white text-dark font-medium"
              >Portfolio Name</small
            >
            <el-form-item prop="name" class="">
              <el-input
                @input="handleUpperCase"
                placeholder="Enter Portfolio Name"
                v-model="ruleForm.name"
              ></el-input>
              <!-- <el-input
                placeholder="Enter Portfolio Name"
                v-model="ruleForm.name"
              ></el-input> -->
            </el-form-item>
          </div>
          <div class="mb-3">
            <small class="fsize12 bg-white text-dark font-medium">Image</small>
            <!-- <el-upload
              class="upload-demo"
              drag
              action="#"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList"
              accept="image/*"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Drop file here or <em>click to upload</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                jpg/png files with a size less than 500kb
              </div>
            </el-upload> -->
            <FileUpload
              v-if="image == null"
              :image="image"
              :onSuccess="handleSuccess"
              class="m-auto"
            />

            <div v-else class="relative">
              <img
                :src="
                  image.slice(0, 4) === 'data' ? image : `${$imageURL}${image}`
                "
                ref="cover"
                class="object-cover imgpre w-full"
              />

              <div
                class="absolute top-0 right-0 bg-white rounded-full p-1"
                v-if="image"
              >
                <feather-icon
                  icon="XIcon"
                  svgClasses="w-3 h-3"
                  class="cursor-pointer"
                  @click="handleRemove"
                />
              </div>
            </div>
            <el-checkbox v-model="checkedall">Add Sub categories</el-checkbox>
          </div>
          <div class="grid grid-cols-2 gap-4 mt-6">
            <vs-button
              type="primary"
              class="bg-primary rounded-full font-semibold py-5 fsize14"
              @click.prevent="handleSubmit('ruleForm')"
              >Save</vs-button
            >

            <vs-button
              type="secondary"
              class="bg-secondary rounded-full font-semibold py-5 fsize14"
              @click="handleClose"
              >Cancel</vs-button
            >
          </div>
        </div>
      </el-form>
    </el-dialog>
    <div class="flex w-full justify-between items-center">
      <div class="w-1/2">
        <div class="relative">
          <el-input
            placeholder="Please input"
            v-model="search"
            class="rounded-none w-full"
          ></el-input>
          <div class="absolute top-0 right-0 mt-2 mr-2">
            <feather-icon icon="SearchIcon" class="" />
          </div>
        </div>
      </div>
      <div class="w-1/2 flex justify-end">
        <vs-button
          color="primary"
          @click="openDialog('Add')"
          class="bg-primary px-8"
          >Add Portfolio</vs-button
        >
      </div>
    </div>
    <div class="w-full">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
        header-row-class-name="thead-light table-th-color"
      >
        <el-table-column prop="image" label="Portfolio Image" min-width="50px">
          <template v-slot="{ row }">
            <img
              :src="getImage(row.image)"
              class="img-wh10 object-cover w-full"
              :alt="row.name"
            />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="Portfolio Name" min-width="50px">
          <template v-slot="{ row }">
            <P class="text-gray">{{ row.name }}</P>
          </template>
        </el-table-column>
        <el-table-column prop="city" label="Album" min-width="50px">
          <template v-slot="{ row }">
            <P
              class="text-gray cursor-pointer underline"
              @click="handleAddAlbum(row)"
              >+ Add Album</P
            >
          </template>
        </el-table-column>

        <el-table-column prop="city" label="Actions" min-width="40px">
          <template v-slot="{ row }">
            <div class="flex gap-1 items-center">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
                @click="openDialog('Edit', row)"
              />
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-4 h-4"
                @click="deletePopup(row._id)"
                class="cursor-pointer"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="w-full flex justify-end mt-6" v-if="totalRows">
      <el-pagination
        background
        layout="prev,pager,next"
        :total="totalRows"
        :page-size="perPage"
        @current-change="setPage"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import FileUpload from "@/components/FileUpload.vue";
import { mapState } from "vuex";
const debounce = (fn, ms = 0) => {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};
export default {
  data() {
    return {
      drawer: false,
      drawer2: false,
      activeName: "first",
      centerDialogVisibleg: false,
      centerDialogVisiblef: false,
      tableData: [
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
      ],

      search: "",
      totalRows: 0,
      perPage: 10,
      currentPage: 1,
      categoryId: "",
      AddEdit: "Add",

      ruleForm: {
        name: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "Please Enter Portfolio Name",
            trigger: "blur",
          },
          {
            pattern: /^[a-zA-Z0-9\- ]*$/,
            message: "Only Alpha Numeric and '-' are Allowed",
            trigger: "blur",
          },
        ],
      },

      image: null,
      coverImage: null,
      checkedInValue: false,
      checkedall: false,
    };
  },
  components: {
    FileUpload,
  },
  computed: {
    ...mapState("admin", ["login"]),
    ...mapState("user", {
      selectedProject: "selectedProject",
    }),
    ...mapState("baseAdminCategory", {
      category: "category",
    }),
  },
  watch: {
    async currentPage() {
      await this.getCategory();
    },
    search: {
      handler: debounce(async function (val) {
        this.currentPage = 1;
        this.getCategory();
      }, 500),
    },
  },
  methods: {
    handleUpperCase(value) {
      // this.ruleForm.name = value.toUpperCase();
      this.ruleForm.name = value;
    },
    openDialog(action, data = {}) {
      this.AddEdit = action;
      this.centerDialogVisibleg = true;
      console.log(data, "DATA");
      if (action === "Edit") {
        this.resetForm();
        this.ruleForm.name = data.name ? data.name : "";
        this.image = data.image ? data.image : "";
        this.categoryId = data._id ? data._id : "";
        this.checkedall = data.isAddSubCategory ? data.isAddSubCategory : "";
      } else {
        this.resetForm();
      }
    },
    handleSubmit(formName) {
      // this.ruleForm.name = this.ruleForm.name.trim();
      this.ruleForm.name = this.ruleForm.name;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.onSubmit();
        } else {
          // this.formfield();
          return false;
        }
      });
    },
    getImage(img) {
      return `${process.env.VUE_APP_IMAGE_URL}/${img}`;
    },
    resetForm() {
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      this.ruleForm.name = "";
      this.image = null;
      this.coverImage = null;
      this.categoryId = "";
      this.checkedall = false;
    },
    handleSuccess(image) {
      this.coverImage = image;
      this.readerData(image);
    },
    readerData(rawFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));
      };
      reader.readAsDataURL(rawFile);
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
    handleAddAlbum(category) {
      this.$store.commit("baseAdminCategory/SELECTED_CATEGORY", category);
      this.handleClick("album");
    },
    // handleAddAlbumPopup(category) {
    //   this.$store.commit("baseAdminCategory/SELECTED_CATEGORY", category);
    //   this.handleClick("album");
    // },
    async deletePopup(categoryId) {
      this.$swal({
        title: "Are you sure?",
        type: "Warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Delete it",
        cancelButtonText: "No, keep it",
        confirmButtonColor: "#cd3197",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.$swal("Deleted", "Successfully deleted", "success");
          this.handleDelete(categoryId);
        }
      });
    },
    async handleDelete(categoryId) {
      let payload = {
        categoryId: categoryId,
        adminId: this.login._id,
      };
      let data = await this.$store.dispatch(
        "baseAdminCategory/deleteCategoryData",
        payload
      );
      this.currentPage = 1;
      this.getCategory();
    },
    async onSubmit() {
      const payload = new FormData();
      payload.append("name", this.ruleForm.name);
      if (this.coverImage) {
        payload.append("image", this.coverImage);
      }
      payload.append("isAdmin", true);
      payload.append("isAddSubCategory", this.checkedall);
      payload.append("adminId", this.login._id);

      if (!this.coverImage && !this.image) {
        this.$swal.fire({
          text: "Please Upload Image!",
          confirmButtonText: "Okay",
          confirmButtonColor: "#cd3197",
          showCancelButton: false,
        });
        return;
      }

      let loader;
      try {
        console.log(payload);
        loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });

        if (this.AddEdit === "Edit") {
          payload.append("categoryId", this.categoryId);

          const updateCategory = await this.$store.dispatch(
            "baseAdminCategory/editCategoryData",
            payload
          );

          if (updateCategory.code === 200) {
            // console.log(createCategory);
            loader.close();
            this.handleClose();
            await this.$swal({
              title: "Portfolio Updated Successfully!",
              type: "success",
              showCancelButton: false,
              confirmButtonColor: "#830c81",
            });
          }
        } else {
          const createCategory = await this.$store.dispatch(
            "baseAdminCategory/addCategoryData",
            payload
          );

          if (createCategory.code === 200) {
            // console.log(createCategory);
            loader.close();
            this.handleClose();
            await this.$swal({
              title: "Portfolio Created Successfully!",
              type: "success",
              showCancelButton: false,
              confirmButtonColor: "#830c81",
            });
          }
        }
        this.ruleForm.name = "";
        this.image = null;
        this.coverImage = null;
        this.getCategory();
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    async getCategory() {
      let curPage = this.currentPage - 1;
      let payload = {
        limit: this.perPage,
        offset: curPage,
      };
      let loader;

      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });

      try {
        loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        const getCategory = await this.$store.dispatch(
          "baseAdminCategory/getCategoryData",
          payload
        );
        // console.log(getCategory);
        loader.close();
        if (getCategory.code === 200) {
          this.totalRows = this.category.totalCount;
          this.tableData = this.category.result;
        }
      } catch (error) {
        console.log(error);
        loader.close();
      }
    },
    setPage(page) {
      this.currentPage = page;
    },
    handleClose() {
      this.centerDialogVisibleg = false;
    },
  },
  async mounted() {
    await this.getCategory();
  },
};
</script>
<style>
.imgpre {
  height: 270px;
  border-radius: 8px;
  width: 100%;
}
</style>
